const conselho_etica = {
  pessoas: [
    {
      nome: 'Valdecyr Maciel Gomes',
      cargo: 'Presidente',
      descricao: ' ',
      imagem: 'conselho1',
    },
    {
      nome: 'Luiz Eduardo Passos Maia',
      cargo: 'Vice-presidente',
      descricao: 'Brookfield Brasil',
      imagem: 'conselho2',
    },
    {
      nome: 'Cassio Fernando Von Gal',
      cargo: 'Conselheiro',
      descricao: 'Banco Bocom BBM',
      imagem: 'conselho3',
    },
    {
      nome: 'Luiz Augusto Candiota',
      cargo: 'Conselheiro',
      descricao: 'Lacan Investimentos e Participações',
      imagem: 'conselho4',
    },
    {
      nome: 'Luís Fernando Affonso',
      cargo: 'Conselheiro',
      descricao: 'Franklin Templeton',
      imagem: 'conselho5',
    },
    {
      nome: 'Silmara Baccani',
      cargo: 'Conselheira',
      descricao: 'BNY Mellon',
      imagem: 'conselho6',
    },
  ],
};

export { conselho_etica };
